import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Pause, Trash2 } from "lucide-react";
import { api, formatApiError } from "../../lib/api";
import { H1, Sub, IconBtn } from "./_shared";

export default function InvoicesSection() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  const load = useCallback(async () => { const { data } = await api.get(`/admin/invoices${filter ? `?status=${filter}` : ""}`); setItems(data); }, [filter]);
  useEffect(() => { load(); }, [load]);
  const setPaid = async (id) => { try { await api.patch(`/admin/invoices/${id}`, { status: "paid" }); toast.success("Marked paid"); load(); } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || e.message); } };
  const cancel = async (id) => { try { await api.patch(`/admin/invoices/${id}`, { status: "cancelled" }); toast.success("Cancelled"); load(); } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || e.message); } };
  const del = async (id) => { if (!window.confirm("Delete invoice?")) return; try { await api.delete(`/admin/invoices/${id}`); toast.success("Deleted"); load(); } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || e.message); } };
  return (
    <div data-testid="cp-invoices">
      <H1>Invoices</H1>
      <Sub>All invoices across the platform.</Sub>
      <div className="mt-4 flex gap-2">
        {["", "sent", "paid", "cancelled", "refunded"].map((s) => (
          <button key={s || "all"} onClick={() => setFilter(s)} className={`pp-chip ${filter === s ? "pp-chip-active" : ""}`} data-testid={`cp-invoice-filter-${s || "all"}`}>{s || "All"}</button>
        ))}
      </div>
      <div className="mt-4 pp-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs uppercase tracking-wider text-zinc-500 bg-white/5"><tr>
            <th className="text-start px-4 py-3">Description</th><th className="text-start px-4 py-3">Amount</th>
            <th className="text-start px-4 py-3">Status</th><th className="text-start px-4 py-3">Created</th>
            <th className="text-end px-4 py-3">Actions</th>
          </tr></thead>
          <tbody>
            {items.map((inv) => (
              <tr key={inv.id} className="border-t border-white/5" data-testid={`cp-invoice-row-${inv.id}`}>
                <td className="px-4 py-2">{inv.description || "Invoice"}</td>
                <td className="px-4 py-2 font-bold">{inv.amount} {inv.currency}</td>
                <td className="px-4 py-2"><span className="pp-chip">{inv.status}</span></td>
                <td className="px-4 py-2 text-zinc-500 text-xs">{inv.created_at ? new Date(inv.created_at).toLocaleString() : "—"}</td>
                <td className="px-4 py-2 text-end">
                  <div className="inline-flex gap-1">
                    {inv.status !== "paid" && <button onClick={() => setPaid(inv.id)} data-testid={`cp-invoice-pay-${inv.id}`} className="pp-btn-secondary px-3 py-1 rounded-lg text-xs">Mark paid</button>}
                    {inv.status !== "cancelled" && <IconBtn onClick={() => cancel(inv.id)} title="Cancel" data-testid={`cp-invoice-cancel-${inv.id}`}><Pause size={14} /></IconBtn>}
                    <IconBtn onClick={() => del(inv.id)} danger title="Delete" data-testid={`cp-invoice-del-${inv.id}`}><Trash2 size={14} /></IconBtn>
                  </div>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="text-center text-zinc-500 py-10">No invoices.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
